import '../../../utils/onse.css';

import React, { useReducer, useState } from 'react';
import { toast } from 'react-toastify';

import postProductIds from '../../../api/oc_product/oneStock/postProducts';

function SendToOneStock() {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const productIds = [
    ...new Set(
      value

        .split(/[,\n]+/)

        .map((id) => id.trim())

        .filter(Boolean),
    ),
  ];
  const submitIndexAction = () => {
    console.log('New');
  };
 const handleSubmit = async (event) => {
  console.log(1);
 event.preventDefault();
 if (!productIds.length || loading) return;
 setLoading(true);
 setMessage(null);
 try {
    console.log(2);

   await postProductIds(productIds);
   setMessage({
     type: 'success',
     text: `${productIds.length} product${productIds.length === 1 ? '' : 's'} sent successfully.`,
   });
   setValue('');
 } catch (error) {
   console.error('failed', error);
   setMessage({
     type: 'error',
     text: 'Unable to send products. Please try again.',
   });
 } finally {
   setLoading(false);
 }
};

  return (
    <main className="send-products-page">
      <section className="send-products-card">
        <div className="send-products-accent" />
        <form className="send-products-form" onSubmit={handleSubmit}>
          <h1>Send products to OnseStock</h1>
          <p className="send-products-description">
            Enter the product IDs you want to send to OnseStock.
          </p>
          <label htmlFor="product-ids">Product IDs</label>
          <textarea
            id="product-ids"

            value={value}

            onChange={(event) => {
              setValue(event.target.value);

              setMessage(null);
            }}

            placeholder={'e.g. 123456\n123457\n123458'}

            disabled={loading}

            aria-describedby="product-ids-help"
          />
          <div className="send-products-meta">
            <span id="product-ids-help">
              Separate IDs with commas or new lines.
            </span>
            <span aria-live="polite">
              {productIds.length}
              {' '}
              {productIds.length === 1 ? 'product' : 'products'}
            </span>
          </div>
          <div className="send-products-footer">
            <button type="submit" disabled={!productIds.length || loading}>
              {loading ? 'Sending…' : 'Send to OnseStock'}

              {!loading && <span aria-hidden="true">→</span>}
            </button>
          </div>

          {message && (
            <p
              className={`send-products-message ${message.type}`}

              role={message.type === 'error' ? 'alert' : 'status'}
            >
              {message.text}
            </p>
          )}
        </form>
      </section>
    </main>
  );
  // return (
  //   <Container maxWidth="md" sx={{ mt: 4 }}>
  //     <section className="w-full">
  //       {/* flex-col flex-wrap h-[calc(100vh-250px)] */}
  //       <form className="flex flex-col w-full gap-8 xl:flex-row">
  //         <section className="flex flex-col w-full gap-8">
  //             <div className="flex flex-col w-[260px]">

  //               <div className="flex items-center gap-2">
  //                 <Typography variant="body2">
  //                   Enter  Product Ids
  //                 </Typography>
  //               </div>
  //               <Box className="flex items-center justify-center gap-6 mt-2">
  //                 <TextField
  //                   label="Product Ids"
  //                   placeholder="Type or Paste in your Product Ids here."
  //                   multiline
  //                   rows={6}
  //                   inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
  //                   value={state.productIds}
  //                   onChange={(e) => getProductIds(e)}
  //                   error={productIdLengthError}
  //                   helperText={productIdLengthError ? 'One or more Id\'s contain 10 or more digits' : ''}
  //                 />
  //               </Box>

  //             </div>
  //           <div className="w-full">
  //             <Box className="flex items-center justify-center gap-6 mt-2">
  //               <Button
  //                 variant="contained"
  //                 disabled={submitDisabled}
  //                 onClick={() => {
  //                   submitIndexAction(false);
  //                 }}
  //               >
  //                 Submit
  //               </Button>
  //               {/* {!submitDisabled && (
  //                 <div
  //                   className="absolute left-0 right-0 z-0 ml-auto mr-auto rounded top-1 bg-primary-400 animate-ping"
  //                 />
  //               )} */}
  //             </Box>
  //           </div>

  //         </section>
  //       </form>
  //     </section>
  //   </Container>
  // );
}

export default SendToOneStock;
